function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m8.334 15.834-.143.143a3.333 3.333 0 0 1-4.714 0l-.286-.286a3.333 3.333 0 0 1 0-4.714L5.977 8.19a3.333 3.333 0 0 1 4.714 0l.286.286a3.32 3.32 0 0 1 .95 1.94",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8.074 10.417a3.32 3.32 0 0 0 .95 1.94l.286.286a3.334 3.334 0 0 0 4.715 0l2.786-2.786a3.333 3.333 0 0 0 0-4.714l-.286-.286a3.333 3.333 0 0 0-4.714 0L11.667 5",
    style: {
      fill: "none"
    }
  }));
};
export default SvgCopy;